import 'twin.macro';
import HtmlViewer from '@teetsh/app/src/components/HtmlViewer';

interface Props {
  originalText: string;
  streamingText: string;
  mode?: 'words' | 'chars';
  isStreaming?: boolean;
}

function StreamingHtmlRenderingDiffView({
  streamingText,
  isStreaming = true,
}: Props) {
  return (
    <div tw="relative">
      <HtmlViewer text={streamingText} onChange={() => {}} />
      {isStreaming && (
        <span tw="ml-0.5 inline-block w-0.5 h-4 bg-neutral-intense animate-pulse align-middle" />
      )}
    </div>
  );
}

export default StreamingHtmlRenderingDiffView;
